module.exports = __webpack_public_path__ + "img/guidebook1.ffdc2a0c.png";